import { intersection } from "es-toolkit/compat";

export function noStreamShortCodeOptionsMatch(
  shortCodeOptions,
  streamShortCodes
) {
  return intersection(shortCodeOptions, streamShortCodes).length === 0;
}
